import { HOST } from 'constants/api';
import responseParser from 'utils/api/responseParser';
import checkStatus from 'utils/api/checkStatus';
import errorParser from 'utils/api/errorParser';

const getUserData = async (path: string): Promise<any> => {
  const token = localStorage.getItem('token') || '';

  const headers = {
    Authorization: token,
  };

  const url = `${HOST}${path}`;

  return fetch(url, {
    method: 'GET',
    headers,
  })
    .then(checkStatus)
    .then(responseParser)
    .catch(errorParser);
};

export default getUserData;
